import { Carousel as bsCarousel } from 'bootstrap';

// Test via a getter in the options object to see if the passive property is accessed
var supportsPassive = false;
try {
  var opts = Object.defineProperty({}, 'passive', {
    get: function() {
      supportsPassive = true;
    }
  });
  window.addEventListener("testPassive", null, opts);
  window.removeEventListener("testPassive", null, opts);
} catch (e) {}

class CarouselSwipe {

    constructor(el) {
        this.el = el;
        this.threshold = 60;
        this.bsCarousel = bsCarousel.getOrCreateInstance(this.el);
        this.touchStartX = null;
        this.el.addEventListener('touchstart', (e) => {
            if (e.touches.length == 1) {
                let touch = e.touches[0];
                this.touchStartX = touch.pageX;
            }
        }, supportsPassive ? { passive: true } : false);
        this.el.addEventListener('touchmove', (e) => {
            if (this.touchStartX != null) {
                let touchCurrentX = e.changedTouches[0].pageX;
                if ((touchCurrentX - this.touchStartX) > this.threshold) {
                    this.touchStartX = null;
                    this.bsCarousel.prev();
                } else if ((this.touchStartX - touchCurrentX) > this.threshold) {
                    this.touchStartX = null;
                    this.bsCarousel.next();
                }
            }
        }, supportsPassive ? { passive: true } : false);
        this.el.addEventListener('touchend', () => {
            this.touchStartX = null;
        }, supportsPassive ? { passive: true } : false);
    }

}

// export the default function to create
export function createFrom(wrappers) {
    wrappers.forEach((node) => {
        // if node is an element
        if (node.nodeType === 1) {
            new CarouselSwipe(node);
        }
    });
}